import React from "react";
import { Box, SxProps, Theme } from "@mui/material";
import delegationTokens from "../Delegation.tokens";

interface DelegationIconProps {
  sx?: SxProps<Theme>;
  /** Stroke colour; defaults to the surrounding text colour. */
  color?: string;
}

/**
 * Inline line icon traced from the Delegation design. Size and colour come from
 * `Delegation.styles.ts` / `Delegation.tokens.ts`, never from this file.
 */
export const DateRangeCalendarIcon: React.FC<DelegationIconProps> = ({
  sx,
  color,
}) => (
  <Box
    component="svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke={color ?? "currentColor"}
    strokeWidth={delegationTokens.dateRange.iconStrokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    sx={sx}
  >
    <rect x="3" y="4" width="18" height="18" rx="2" />
    <path d="M16 2v4" />
    <path d="M8 2v4" />
    <path d="M3 10h18" />
  </Box>
);

export default DateRangeCalendarIcon;
